import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "./hooks/use-fetch-options.js";
import TimePeriodInput from "../../../../components/reports/time-period-input/time-period-input.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { lanesOptions, archiverOptions } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <TimePeriodInput filters={filters} setFilters={setFilters} singleRow={true}/>

                    <SelectComponent
                        label="Câmeras"
                        isMulti={true}
                        wrapValues={true}
                        options={lanesOptions}
                        value={filters.lanes}
                        onChange={(value) => setFilters(prev => ({...prev, lanes: value}))}
                        instanceId="lanes"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Archiver"
                        isMulti={true}
                        wrapValues={true}
                        options={archiverOptions}
                        value={filters.archiver}
                        onChange={(value) => setFilters(prev => ({...prev, archiver: value}))}
                        instanceId="archiver"
                        classNameWrapper={"w-full"}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;